import React from "react";
import { IListingSummary } from "../../lib/Listing";
import { IoBedOutline } from "react-icons/io5";
import { RiRuler2Line } from "react-icons/ri";
import { BiBath } from "react-icons/bi";
import { AiOutlineTeam } from "react-icons/ai";
import { MdPhotoSizeSelectLarge } from "react-icons/md";

export interface IVitalIconsProps {
  listing: IListingSummary;
  replaceIconsForText?: boolean;
  bedsExtraDisplayRule?: (listing?: IListingSummary) => boolean;
  bathsExtraDisplayRule?: (listing?: IListingSummary) => boolean;
  sleepsExtraDisplayRule?: (listing?: IListingSummary) => boolean;
  bathsHalfExtraDisplayRule?: (listing?: IListingSummary) => boolean;
  sqftExtraDisplayRule?: (listing?: IListingSummary) => boolean;
  lotacresExtraDisplayRule?: (listing?: IListingSummary) => boolean;
  flagBox?: (listing?: IListingSummary) => React.ReactNode;
  flagBoxPosition?: "start" | "end";
}

export const VitalsIcons: React.FC<IVitalIconsProps> = ({
  listing,
  replaceIconsForText = false,
  bedsExtraDisplayRule = () => { return true; },
  bathsExtraDisplayRule = () => { return true; },
  bathsHalfExtraDisplayRule = () => { return true; },
  sleepsExtraDisplayRule = () => { return true; },
  sqftExtraDisplayRule = () => { return true; },
  lotacresExtraDisplayRule = () => { return true; },
  flagBox,
  flagBoxPosition = "end"
}) => {
  return (
    <>
      {flagBox && flagBoxPosition === "start" && flagBox(listing)}
      {listing.beds && listing.beds > 0 && bedsExtraDisplayRule(listing) ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && <IoBedOutline />}
          {listing.beds}
          {replaceIconsForText && <span className="not-sr-only">&nbsp;Beds</span>}
          <span className="sr-only">bed</span>
        </div>
      ) : null}
      {listing.baths && listing.baths > 0 && bathsExtraDisplayRule(listing) ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && <BiBath />}
          {listing.baths}
          {replaceIconsForText && <span className="not-sr-only">&nbsp;Baths</span>}
          <span className="sr-only">bath</span>
        </div>
      ) : null}
      {listing.baths_3_4 && listing.baths_3_4 > 0 ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && <BiBath style={{ clipPath: 'polygon(0 0, 100% 0, 60% 100%, 0 100%)' }} />}
          {listing.baths_3_4}
          {replaceIconsForText && <span>&nbsp;3/4 Bath</span>}
          <span className="sr-only">3/4 bath</span>
        </div>
      ) : null}
      {listing.bathsHalf && listing.bathsHalf > 0 && bathsHalfExtraDisplayRule(listing) ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && <BiBath style={{ clipPath: 'polygon(0 0, 60% 0, 60% 100%, 0 100%)' }} />}
          {listing.bathsHalf}
          {replaceIconsForText && <span>&nbsp;Half Bath</span>}
          <span className="sr-only">half bath</span>
        </div>
      ) : null}
      {listing.sleeps && listing.sleeps > 0 && sleepsExtraDisplayRule(listing) ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && (<><AiOutlineTeam /> <span>Sleeps </span></>)}
          {listing.sleeps}
          {replaceIconsForText && <span>&nbsp;Sleeps</span>}
        </div>
      ) : null}
      {listing.sqft && listing.sqft > 0 && sqftExtraDisplayRule(listing) ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && <RiRuler2Line />}
          {new Intl.NumberFormat().format(listing.sqft)}{" "}
          {!replaceIconsForText && (<>
            <span className="not-sr-only">sf</span>
            <span className="sr-only">square feet</span>
          </>)}
          {replaceIconsForText && <span>SqFt</span>}
        </div>
      ) : null}
      {listing.lotacres && listing.lotacres > 0 && lotacresExtraDisplayRule(listing) ? (
        <div className="whitespace-nowrap">
          {!replaceIconsForText && <MdPhotoSizeSelectLarge />}
          {listing.lotacres}
          {!replaceIconsForText && (<>
            <span className="not-sr-only">ac</span>
            <span className="sr-only">acres</span>
          </>)}
          {replaceIconsForText && <span>&nbsp;AC</span>}
        </div>
      ) : null}
      {flagBox && flagBoxPosition === "end" && flagBox(listing)}
    </>
  );
};
